import { generate } from 'short-uuid';
import { codes } from 'constants/payment';

export const handlePaymentSubmit = ({
  cashTendered,
  totalPriceToBePaid,
  payAndConfirm,
  takeDeposit,
  addPayment,
  bookingReference,
  currency,
  isOnHold,
  method,
  reference,
  externalReference,
  reason
}) => {
  const cash = parseFloat(cashTendered);
  const totalPrice = parseFloat(totalPriceToBePaid);
  const isTotalPayment = cash >= totalPrice;
  const isEVoucherPayment = method === codes.EVOUCHER;
  let mutation;

  if (isOnHold) {
    mutation = isEVoucherPayment || !isTotalPayment ? addPayment : takeDeposit;
  } else {
    mutation = isTotalPayment ? payAndConfirm : addPayment;
  }

  return mutation({
    variables: {
      bookingReference,
      payments: [
        {
          amount: cash > totalPrice ? totalPrice : cash,
          currency,
          provider: 'NONE',
          method,
          status: 'S',
          external_reference: externalReference,
          reference
        }
      ],
      reason
    }
  });
};

export const handleRefundSubmit = async ({
  membershipNumber,
  addPayoutAndBalance,
  bookingReference,
  completeTransaction,
  currency,
  externalReference,
  method,
  paymentAmount,
  reference,
  totalPriceToBePaid,
  updatePayments,
  voucherAlias = '',
  loyaltyPoints,
  isRefundingEntireBlueVoucherBooking = false,
  blueVoucherAmount = 0,
  isOverpaid = false
}) => {
  const cash = parseFloat(paymentAmount);
  const totalPrice = parseFloat(totalPriceToBePaid);

  const payoutAmount = cash > totalPrice ? totalPrice : cash;
  const ref = generate();

  let paymentReference = `${reference}-${ref}`;

  if (voucherAlias) {
    paymentReference = `${reference}-${ref}_${voucherAlias}`;
  }

  if (loyaltyPoints) {
    paymentReference = `${reference}-${membershipNumber ? membershipNumber + '-' : ''}${ref}-${loyaltyPoints}`;
  }

  if (isRefundingEntireBlueVoucherBooking) {
    paymentReference = `${reference}-${ref}-${blueVoucherAmount}`;
  }

  if (isOverpaid) {
    paymentReference = `${paymentReference}-overpaid`;
  }

  const addPayoutAndBalanceResponse = await addPayoutAndBalance({
    variables: {
      bookingReference,
      amount: Math.abs(payoutAmount),
      currency,
      method,
      externalReference,
      reference: paymentReference
    }
  });

  if (completeTransaction) {
    const updatePaymentsResponse = await updatePayments({
      variables: {
        bookingReference,
        payments: [
          {
            ref: parseInt(reference, 10),
            status: 'S',
            refundProcessed: true
          }
        ]
      }
    });

    return [addPayoutAndBalanceResponse, updatePaymentsResponse];
  }

  return [addPayoutAndBalanceResponse];
};
